const UserOrigin = {
  0: 'Platform',
  1: 'Legacy',
};

export default UserOrigin;
